var Gsap = (function($) {
  function initGsap() {
    gsap.registerPlugin(ScrollTrigger);

    const section = document.querySelector(".home-intro");
    const wrapper = document.querySelector(
      ".home-intro-wrapper.horizontal-scroll"
    );

    if (!section || !wrapper) return;

    // ---------------------------------------------
    // Horizontal Scroll responsive (desktop / mobile)
    // ---------------------------------------------
    const rightCol = section.querySelector(".home-intro--right");

    ScrollTrigger.matchMedia({
      // --------------------
      // DESKTOP (>= 891px)
      // --------------------
      "(min-width: 891px)": function() {
        gsap.to(wrapper, {
          x: () => {
            const viewportWidth = rightCol
              ? rightCol.clientWidth
              : section.clientWidth;

            const scrollLength = wrapper.scrollWidth - viewportWidth;
            return scrollLength > 0 ? -scrollLength : 0;
          },
          ease: "none",
          scrollTrigger: {
            id: "home-intro-horizontal",
            trigger: section,
            start: "top top+=120",
            end: () => {
              const viewportWidth = rightCol
                ? rightCol.clientWidth
                : section.clientWidth;

              const scrollLength = wrapper.scrollWidth - viewportWidth;
              return "+=" + (scrollLength > 0 ? scrollLength : 0);
            },
            scrub: true,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
          },
        });
      },

      // --------------------
      // MOBILE (< 890px)
      // --------------------
      "(max-width: 890px)": function() {
        gsap.to(wrapper, {
          x: () => {
            const viewportWidth = section.clientWidth;
            const scrollLength = wrapper.scrollWidth - viewportWidth;
            return scrollLength > 0 ? -scrollLength : 0;
          },
          ease: "none",
          scrollTrigger: {
            id: "home-intro-horizontal",
            trigger: section,
            start: "top top+=50",
            end: () => {
              const viewportWidth = section.clientWidth;
              const scrollLength = wrapper.scrollWidth - viewportWidth;
              return "+=" + (scrollLength > 0 ? scrollLength : 0);
            },
            scrub: true,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
          },
        });
      },
    });

    // ---------------------------------------------
    // Animación de entrada de cada bloque del scroll horizontal
    // (usa containerAnimation = horizontalTween, OJO)
    // ---------------------------------------------
    // ---------------------------------------------
    // Aparición global de TODOS los bloques
    // ---------------------------------------------
    gsap.from(".home-intro-block", {
      opacity: 0,
      y: 40,
      scale: 0.95,
      duration: 0.8,
      ease: "power3.out",
      stagger: 0.05, // opcional, queda más fino
      scrollTrigger: {
        trigger: section,
        start: "top top+=400", // cuando empieza el scroll horizontal
        toggleActions: "play none none none",
      },
    });

    // ---------------------------------------------
    // Animación entrada home-history (fade + scale)
    // ---------------------------------------------
    if (document.querySelector(".home-history__image")) {
      gsap.fromTo(
        ".home-history__image",
        { opacity: 0, scale: 0.96 },
        {
          opacity: 1,
          scale: 1,
          duration: 1.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".home-history",
            start: "top-=200 top",
            toggleActions: "play none none none",
          },
        }
      );

      // ---------------------------------------------
      // Parallax home-history (solo Y, no toca opacity/scale)
      // ---------------------------------------------
      gsap.to(".home-history__image", {
        y: -70,
        ease: "none",
        scrollTrigger: {
          trigger: ".home-history",
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });

      // ---------------------------------------------
      // Animación home-why (stagger izquierda → derecha)
      // ---------------------------------------------
      gsap.from(".home-why-block", {
        x: -60,
        opacity: 0,
        duration: 1.1,
        ease: "back.out(1.8)", // rebote sutil
        stagger: {
          each: 0.18,
          from: "start",
        },
        scrollTrigger: {
          trigger: ".home-why",
          start: "top-=150 top",
          toggleActions: "play none none none",
        },
      });

      if (!document.querySelector(".home-book")) return;

      const yearEl = document.querySelector(".home-book__year");

      const yearObj = { value: 2025 };

      gsap.to(yearObj, {
        value: 1890,
        duration: 3,
        ease: "power2.out",
        snap: { value: 1 },
        scrollTrigger: {
          trigger: ".home-book",
          start: "top-=180 top",
          once: true,
        },
        onUpdate: () => {
          yearEl.textContent = yearObj.value;
        },
      });

      // ---------------------------------------------
      // Home History heading: compact → space-between
      // ---------------------------------------------
      const heading = document.querySelector(".home-history__heading");
      const words = heading?.querySelectorAll("span");

      if (heading && words.length) {
        // 1️⃣ Medimos posiciones finales
        const positions = [];
        words.forEach((word) => {
          positions.push(word.getBoundingClientRect().left);
        });

        // 2️⃣ Compactamos visualmente (pero legibles)
        const headingRect = heading.getBoundingClientRect();
        const headingCenter = headingRect.left + headingRect.width / 2;

        // Qué porcentaje del ancho ocupará el estado compacto
        const compactRatio = 0.36; // 60% (ajusta entre 0.55 y 0.7)
        const compactWidth = headingRect.width * compactRatio;

        // Punto inicial del bloque compacto
        const compactStart = headingCenter - compactWidth / 2;

        words.forEach((word) => {
          const wordRect = word.getBoundingClientRect();
          const wordCenter = wordRect.left + wordRect.width / 2;

          // Proporción de la palabra dentro del heading
          const progress = (wordCenter - headingRect.left) / headingRect.width;

          // Posición compacta proporcional
          const targetCenter = compactStart + progress * compactWidth;

          gsap.set(word, {
            x: targetCenter - wordCenter,
          });
        });

        // 3️⃣ Animamos a su posición real (x: 0)
        gsap.to(words, {
          x: 0,
          duration: 1.4,
          ease: "power3.out",
          stagger: 0.08,
          scrollTrigger: {
            trigger: ".home-history",
            start: "top-=300 top",
            once: true,
          },
        });
      }

      // ---------------------------------------------
      // Animación circle timeline (ping-pong CORRECTO)
      // ---------------------------------------------
      const circle = document.querySelector("#timeline-circle");
      const wrapperElement = document.querySelector(
        ".home-history-timeline-wrapper"
      );

      if (circle && wrapperElement) {
        // Función para calcular la distancia correcta
        const getDistance = () => {
          const wrapperWidth = wrapperElement.offsetWidth;
          const circleWidth = circle.offsetWidth;

          // llegar al 97% del recorrido, NO al final exacto
          return (wrapperWidth - circleWidth) * 0.97;
        };

        // Crear la animación en pausa
        const circleLoop = gsap.to(circle, {
          x: () => getDistance(), // <-- distancia real en píxeles
          duration: 2,
          ease: "sine.inOut",
          repeat: -1,
          yoyo: true,
        });

        circleLoop.pause(); // No empieza todavía

        // ScrollTrigger para activarla cuando aparece
        ScrollTrigger.create({
          trigger: ".home-history--bottom",
          start: "top bottom",
          onEnter: () => circleLoop.play(),
          onLeaveBack: () => {
            circleLoop.pause(0); // vuelve al inicio si vuelves arriba
          },
        });

        // Recalcular si cambia el tamaño de pantalla
        window.addEventListener("resize", () => {
          circleLoop.invalidate(); // recalcula el x: ()=>getDistance()
        });
      }
    }
  }

  function init() {
    if (!$(".home").length) return;
    initGsap();
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(document).ready(Gsap.init);
